import { ArticleIdentifier } from "@tm/models"
import { QueryFunctionContext } from "react-query"
import * as PartsRepository from "../../../data/repositories/parts"
import { ArticlePage, QueryKey } from "../hooks/useArticlesBase"

type Request = Array<ArticleIdentifier & { id?: string }>

export async function fetchArticlesByArticleNoWithOptVehicle({
    queryKey: [, , request],
}: QueryFunctionContext<QueryKey<Request>>) : Promise<ArticlePage>{
    if (!request) {
        return Promise.reject()
    }

    const articles = await PartsRepository.getArticlesByArticleNoWithOptVehicle(request.map((x) => ({ ...x, id: undefined }))).then(
        (articles) => {
            articles.forEach((x) => {
                const relatedRequestItem = request.find(
                    (y) => y.productGroupId === x.productGroup.id && y.supplierArticleNo === x.supplierArticleNo && y.supplierId === x.supplier.id
                )
                if (!relatedRequestItem) {
                    return
                }

                x.id = relatedRequestItem.id ?? x.id // Set the id of each article to the id supplied in the result
                x.fittingSide = x.fittingSide ?? relatedRequestItem.fittingPosition // Set the fitting position of each article to the fitting position supplied (only if undefined)
            })

            return articles
        }
    )

    return {
        data: articles,
        nextPageIndex: undefined
    }
}